import { Icon } from '@tabler/icons-react'

import { BuildPassModule } from './api.graphql'

import { Role } from '@/modules/adminUsers/roles'

export enum QuerySupport {
  BUILDER_AND_PROJECT = 'BUILDER_AND_PROJECT',
  PROJECT_ONLY = 'PROJECT_ONLY',
  BUILDER_ONLY = 'BUILDER_ONLY',
  NEITHER = 'NEITHER',
}

export type NavItemBase = {
  id: Readonly<string>
  buildPassModule?: BuildPassModule
  title: string
  formerlyKnownAs?: string
  path?: string
  icon?: Icon
  iconColour?: string
  iconRotate?: number
  items?: NavItemBase[]
  extra?: React.ReactNode
  help?: string
  querySupport?:
    | QuerySupport
    | { [key: string]: QuerySupport; default: QuerySupport }
  requiredRoles?: Role[]
  actions?: Record<string, (...args: unknown[]) => string>
  disabledForLimitedPermissions?: boolean
  actionsOnly?: boolean
}

export type NavGroupBase = {
  id: string
  title: string
  requiredRoles?: Role[]
  items?: NavItemBase[]
}

export type RouteViewOptions<Tab> = {
  tab: Tab
}
